import React, { useState, useEffect } from "react";
import "./Application.css";
import cancel from "../../assets/cancel.png";
import DeleteCard from "../../Components/Cards/DeleteCard/DeleteCard";
import Loader from "../../Components/Loader/Loader";
import api from "../../utils/api";
import { toast } from "react-hot-toast";

const Application_type_list = (props) => {
  const [loading, setLoading] = useState(0);
  const [typesOfApplications, setTypesOfApplications] = useState([]);
  const [del, setDel] = useState(0);
  const [delId, setDelId] = useState(0);

  const handleClick2 = () => {
    props.setDisp();
  };

  useEffect(() => {
    api
      .get("/applications/types")
      .then((response) => (response = response.data))
      .then((data) => {
        setTypesOfApplications(data);
      });
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await api.delete(`/applications/types/${id}`);
      if (response.status === 200) {
        setDel(null);
        api
          .get("/applications/types")
          .then((response) => (response = response.data))
          .then((data) => {
            toast.success("Application type deleted successfully");
            setDel(0);
            setDelId(0);
            setTypesOfApplications(data);
          });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Failed to delete application type";
      toast.error(errorMessage);
      setDel(0);
      setDelId(0);
    }
  };

  return (
    <div className="advertisment__form_div_open">
      {del ? (
        <DeleteCard
          del={() => {
            handleDelete(delId);
          }}
          close={() => {
            setDel(0);
          }}
        />
      ) : null}
      <div className="advertisment__form">
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
        <h1 style={{padding: '0', fontSize: '24px'}}>Application Type List</h1>
        <div className="advertisment__form_img" onClick={handleClick2}>
          <img src={cancel} alt="cancel" />
        </div>
        </div>
        <table style={{ width: "100%" }}>
          <tr>
            <th className="circular__middle_th">Application type</th>
            <th className="circular__middle_th">Amount</th>
            <th className="circular__middle_th"></th>
          </tr>
          {typesOfApplications.map((a) => {
            return (
              <tr className="circular__middle_tr" key={a.id}>
                <td>{a.name}</td>
                <td>{a.amount || "-"}</td>
                <td>
                  <button
                    type="button"
                    onClick={() => {
                      setDel(1);
                      setDelId(a.id);
                    }}
                    className="circular__middle_td_delete"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </div>
  );
};

export default Application_type_list;